<template>
  <div>
    <div class="container px-6 mt-16">
      <h1 class="text-lg pl-0 md:pl-6 font-bold">
        <span class="text-pink-500">6.</span>
        {{ $t('messages.step_six.title') }}
      </h1>
      <p class="mt-4 px-0 md:px-6 font-semibold">{{ $t('messages.step_six.description') }}</p>
      <div class="flex mt-6 flex-wrap">
        <div v-for="(data, index) in filtered_question" :key="index" class="w-full">
          <div
            class="w-full py-2 px-0 md:px-6"
            :class="{ 'form-group--error': errors.first(`${vvScope}.${data.title}-${index}`) }"
          >
            <label class="font-semibold" for>{{index+1}}. {{data.title[locale]}}</label>
            <select
              v-model="qanswers[index]"
              :name="`${data.title}-${index}`"
              :data-vv-scope="vvScope"
              v-validate="'required'"
              :data-vv-as="data.title[locale]"
              class="h-12 mt-2 block border-blue-500 font-semibold text-gray-700 border rounded w-full px-4 bg-white appearance-none focus:outline-none custom-select"
            >
              <option
                v-for="(item) in data.answers"
                :key="item.id"
                :value="item"
                class="break-words"
              >{{item.answer[locale]}}</option>
            </select>
            <ul>
              <li
                v-for="(error, index) in errors.collect(`${vvScope}.${data.title}-${index}`)"
                :key="index"
                class="text-sm text-red-500 font-semibold mt-2 is-danger"
              >{{ error }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "RegisterStepSix",
  props: ["clickedNext", "currentStep"],
  mixins: [validationMixin],
  data: function() {
    return {
      form: {
        name: ""
      },
      filtered_question: [],
      qanswers: [],
      vvScope: "step6"
    };
  },
  async mounted() {
    await this.getTest();
    await this.showQuestion();
  },
  computed: {
    ...mapState("questions", ["test"]),
    ...mapState("locale", ["locale"])
  },
  methods: {
    ...mapActions("questions", ["getTest"]),
    showQuestion() {
      this.filtered_question = this.test.filter(
        question => question.is_harder === 0
      );
    },
    getData() {
      return this.qanswers;
    },
    changeQuestion() {
      this.filtered_question = this.test.filter(
        question => question.is_harder === 1
      );
      this.qanswers = [];
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
      this.$nextTick(() => {
        this.$validator.reset();
        this.errors.clear();
      });
    }
  }
};
</script>
